module.exports = __webpack_public_path__ + "static/media/image9.c842e21c.jpg";